import React from "react";
import NodataImage from "@/components/atoms/svg/NodataImage";

interface IProp {
  width?: number;
  height?: number;
}

const Nodata = ({ width = 440, height = 440 }: IProp) => {
  return (
    <div className="grid w-full h-fit justify-center">
      <NodataImage
        className={`w-[100%] h-[100%] max-w-[${width}px] max-h-[${height}px]`}
        width={width}
        height={height}
      />
    </div>
  );
};

export default Nodata;
